/** Sichtbarer Hinweis, dass der Gast den Comfort Check-in erledigt hat. */
export function ComfortCheckInMark({
  completed,
  paymentStatus,
}: {
  completed?: boolean;
  paymentStatus?: string | null;
}) {
  if (completed) {
    return (
      <span className="inline-flex items-center rounded-full bg-status-green px-2.5 py-0.5 text-xs font-semibold text-white">
        Comfort Check-in
      </span>
    );
  }
  if (paymentStatus === "paid") {
    return (
      <span className="inline-flex items-center rounded-full bg-status-green/15 px-2.5 py-0.5 text-xs font-semibold text-status-green">
        Zahlung eingegangen
      </span>
    );
  }
  if (paymentStatus === "failed") {
    return (
      <span className="inline-flex items-center rounded-full bg-status-red/15 px-2.5 py-0.5 text-xs font-semibold text-status-red">
        Zahlung fehlgeschlagen
      </span>
    );
  }
  if (paymentStatus === "expired") {
    return (
      <span className="inline-flex items-center rounded-full bg-status-orange/15 px-2.5 py-0.5 text-xs font-semibold text-status-orange">
        Zahlung abgelaufen
      </span>
    );
  }
  if (paymentStatus === "processing") {
    return (
      <span className="inline-flex items-center rounded-full bg-amber-500/15 px-2.5 py-0.5 text-xs font-semibold text-amber-700 dark:text-amber-400">
        Zahlung wird geprüft
      </span>
    );
  }
  return null;
}
